/*
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2025-03-17 14:21:38
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2025-10-10 18:00:38
 * @FilePath: \qctsw-vue\packages\app\src\logic\news\page.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { usePagination } from '@/composables/usePagination'
import { getNewsColumnPageApi } from '@/server'
import type { NewsColumnPageResponse } from '@/server/types'
import { useGetRouteQuery } from '@/shared/function'

export function logicNewsColumnPage() {
  const columnId = useGetRouteQuery('id', '')
  const page = useGetRouteQuery('page', '1')

  const data = ref<NewsColumnPageResponse[]>([])
  const pagination = usePagination({
    type: 'pageNumber',
    key: '栏目数据',
    pageSize: 20,
    request: params => getNewsColumnPageApi({ ...params, articleColumnId: columnId.value }),
  })
  async function getNewsPage(page: number | string = 1) {
    const p = Number.isNaN(Number(page)) ? 1 : Number(page)
    if (p === 1)
      data.value = []

    const { list } = await pagination.loadPaginationData(p) || {}
    if (!list)
      return
    data.value.push(...list)
  }

  useActivatedWatch(() => [
    watch([columnId, page], (nv, ov) => {
      if (nv[0] !== ov[0]) {
        data.value = []
        pagination.initPagination()
      }
      if (JSON.stringify(nv) === JSON.stringify(ov))
        return
      if ((nv[1] !== ov[1] && nv[1]) || nv[0] !== ov[0])
        window.scrollTo(0, 0)

      getNewsPage(page.value)
    }),
  ])

  return {
    page,
    columnId,
    data,
    pagination,
    getNewsPage,
    state: computed(() => pagination.pagination.status),
  }
}
